import { render, staticRenderFns } from "./CourrierType.vue?vue&type=template&id=680decda&"
import script from "./CourrierType.vue?vue&type=script&lang=js&"
export * from "./CourrierType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports